import { memo } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
import { ColorTheme } from "@figma/fpl-themes";
//#region src/icons/icon-16-design-brandicon.tsx
/**
* icon.16.design.brandicon
*
* Keywords: figma, pen, editor
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iIzBkOTlmZiIgZD0iTTAgMmEyIDIgMCAwIDEgMi0yaDEyYTIgMiAwIDAgMSAyIDJ2MTJhMiAyIDAgMCAxLTIgMkgyYTIgMiAwIDAgMS0yLTJ6Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNC4xNCAzLjIwN2ExIDEgMCAwIDEgLjgzNy0uMTgxbDMuNzYyLjg3OGE0LjU3IDQuNTcgMCAwIDEgMy41MzEgNC40NTJsLjQzNy40MzZhMSAxIDAgMCAxIDAgMS40MTVsLTIuNSAyLjVhMSAxIDAgMCAxLTEuNDE0IDBsLS40MzctLjQzN0E0LjU3IDQuNTcgMCAwIDEgMy45NiA4Ljk0OWwtLjA1NC0uMjEtLjg3OS0zLjc2MmExIDEgMCAwIDEgLjI2Ny0uOTM1bC43NS0uNzV6bS41OS44MTMgMi42MjMgMi42MjQtLjAwNi4wMDZhMS41IDEuNSAwIDEgMS0uNjk3LjY5N2wtLjAwNC4wMDQtMi42MjQtMi42MjRMNCA0Ljc0OWwuODc5IDMuNzYzYTMuNTczIDMuNTczIDAgMCAwIDMuODcgMi43MzdsLjc1Ljc1TDEyIDkuNWwtLjc1LS43NWEzLjU3IDMuNTcgMCAwIDAtMi43MzctMy44NzJMNC43NSA0ek04IDcuNWEuNS41IDAgMSAwIDAgMSAuNS41IDAgMCAwIDAtMSIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-13863
*/
const Icon16DesignBrandicon = memo(function Icon16DesignBrandicon(props) {
	return /* @__PURE__ */ jsx(ColorTheme, {
		brand: "design",
		children: /* @__PURE__ */ jsxs("svg", {
			width: "16",
			height: "16",
			fill: "none",
			viewBox: "0 0 16 16",
			...props,
			"data-fpl-icon-size": "16",
			children: [/* @__PURE__ */ jsx("path", {
				fill: "var(--color-bg-brand)",
				d: "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
			}), /* @__PURE__ */ jsx("path", {
				fill: "var(--color-icon-onbrand)",
				fillRule: "evenodd",
				d: "M4.14 3.207a1 1 0 0 1 .837-.181l3.762.878a4.57 4.57 0 0 1 3.531 4.452l.437.436a1 1 0 0 1 0 1.415l-2.5 2.5a1 1 0 0 1-1.414 0l-.437-.437A4.57 4.57 0 0 1 3.96 8.949l-.054-.21-.879-3.762a1 1 0 0 1 .267-.935l.75-.75zm.59.813 2.623 2.624-.006.006a1.5 1.5 0 1 1-.697.697l-.004.004-2.624-2.624L4 4.749l.879 3.763a3.573 3.573 0 0 0 3.87 2.737l.75.75L12 9.5l-.75-.75a3.57 3.57 0 0 0-2.737-3.872L4.75 4zM8 7.5a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
				clipRule: "evenodd"
			})]
		})
	});
});
//#endregion
export { Icon16DesignBrandicon };

//# sourceMappingURL=icon-16-design-brandicon.js.map